import { inject, observer }               from "mobx-react";
import * as React                         from "react";
import ConfirmationModal                  from "../../../Views/Components/Modal/ConfirmationModal";
import ModalService                       from "../../../Service/ModalService";
import { Container }                      from "typedi";
import { ModalStore }                     from "../../../Store/ModalStore";
import { withNamespaces, WithNamespaces } from "react-i18next";
import { ContactUsStore }                  from "../../../Store/ContactUsStore";
import { ContactUs }                       from "../../../Models/ContactUs/ContactUs";

interface IDeleteContactUsViewModelProps extends WithNamespaces {
    ModalStore?: ModalStore;
    ContactUsStore?: ContactUsStore;
    contactUs: ContactUs;
}

@inject(ModalStore.NAME_STORE, ContactUsStore.NAME_STORE)
@observer
class DeleteContactUsViewModel extends React.Component<IDeleteContactUsViewModelProps, {}> {
    private readonly modalService: ModalService;

    constructor(props: IDeleteContactUsViewModelProps) {
        super(props);

        this.modalService = Container.get(ModalService);
    }

    get contactUsStore(): ContactUsStore {
        return this.props.ContactUsStore as ContactUsStore;
    }

    get modalStore(): ModalStore {
        return this.props.ModalStore as ModalStore;
    }

    public action = async () => {
        const {contactUs} = this.props;

        this.contactUsStore.setSpinner(true);
        await this.contactUsStore.deleteById(contactUs.getId());
        const data = await this.contactUsStore.getPaginate();

        this.contactUsStore
            .setPages(data.pages)
            .setContactUss(data.data)
            .setSpinner(false);

        this.modalService.closeModal();
    };

    public render(): React.ReactNode {
        const {t} = this.props;

        return (
            <ConfirmationModal
                handleClose={this.modalService.closeModal}
                open={this.modalStore.getModal().getOpenModal()}
                action={this.action}
                spinner={this.contactUsStore.getSpinner()}
                title={t("confirm.content")}
                content={t("confirm.title")}
            />
        );
    }
}

export default withNamespaces("modal")(DeleteContactUsViewModel);
